import { render, staticRenderFns } from "./GiftcardBlobControls.vue?vue&type=template&id=0d58c1e0&scoped=true&"
import script from "./GiftcardBlobControls.vue?vue&type=script&lang=js&"
export * from "./GiftcardBlobControls.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardBlobControls.vue?vue&type=style&index=0&id=0d58c1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58c1e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
